// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---BbkP1","marginBottom0":"marginBottom0---jdqKF","marginTop0":"marginTop0---xQA7B"};